import {memo} from 'react';

import type {SVGProps} from 'react';

export const PayoutIcon = memo(function PayoutIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none" transform="rotate(180 16 16)">
        <path
          d="M29.2887 22H8.04475C7.28342 22 6.66675 21.3833 6.66675 20.622V8.71134C6.66675 7.95001 7.28342 7.33334 8.04475 7.33334H29.2894C30.0501 7.33334 30.6667 7.95001 30.6667 8.71134V20.6227C30.6667 21.3833 30.0501 22 29.2887 22Z"
          fill="var(--icon-fill-orange)"
        />
        <path
          d="M24.0001 13.3333C24.7365 13.3333 25.3334 12.7364 25.3334 12C25.3334 11.2636 24.7365 10.6667 24.0001 10.6667C23.2637 10.6667 22.6667 11.2636 22.6667 12C22.6667 12.7364 23.2637 13.3333 24.0001 13.3333Z"
          fill="var(--icon-stroke-orange)"
        />
        <path
          d="M8.00008 13.3333C8.73646 13.3333 9.33341 12.7364 9.33341 12C9.33341 11.2636 8.73646 10.6667 8.00008 10.6667C7.2637 10.6667 6.66675 11.2636 6.66675 12C6.66675 12.7364 7.2637 13.3333 8.00008 13.3333Z"
          fill="var(--icon-stroke-orange)"
        />
        <path
          d="M23.7875 5H26.3335C27.0701 5 27.6668 5.59667 27.6668 6.33333V17.6667C27.6668 18.4033 27.0701 19 26.3335 19H10.7095"
          stroke="var(--icon-stroke-orange)"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.96459 19H5.66659C4.92992 19 4.33325 18.4033 4.33325 17.6667V6.33333C4.33325 5.59667 4.92992 5 5.66659 5H20.4966"
          stroke="var(--icon-stroke-orange)"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 15.6667C17.6569 15.6667 19 14.0251 19 12C19 9.97497 17.6569 8.33334 16 8.33334C14.3431 8.33334 13 9.97497 13 12C13 14.0251 14.3431 15.6667 16 15.6667Z"
          stroke="var(--icon-stroke-orange)"
          strokeWidth={2}
          strokeLinejoin="round"
        />
        <path
          d="M16 22.3333V28.3333"
          stroke="var(--icon-stroke-orange)"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3333 25.6667L15.9999 28.3333L18.6666 25.6667"
          stroke="var(--icon-stroke-orange)"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});
